// test789
(789 && 0);
